var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: "" + _vm.estados[_vm.estado].tooltip,
          expression: "`${estados[estado].tooltip}`"
        }
      ]
    },
    [
      _c("vs-icon", {
        attrs: {
          icon: _vm.estados[_vm.estado].icono,
          size: "small",
          color: _vm.estados[_vm.estado].color
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }